export const promo = {
  path: "/promo",
  name: "promo",
  hidden: false,
  component: () => import("@/components/promo/index"),
  meta: {
    title: "Promo",
    icon: "fa-ticket",
    roles: ["pasien", "dokter"]
  }
};
export default promo;



// WEBPACK FOOTER //
// ./src/router/modules/promo.js